import RobotIcon      from '../icons/RobotIcon'
import onClickOutside from 'react-onclickoutside'

class EngineDropdown extends React.PureComponent
  constructor: (props) ->
    super(props)

    @state =
      open: false

    # Refs used for focus (keyboard accessibility)
    @othersButtonRef   = React.createRef()
    @othersDropdownRef = React.createRef()

    # Refs hash used for animation when selecting/adding an engine
    @engineButtonRefs = {}
    for engine in Object.keys(@props.engines)
      @engineButtonRefs[engine] = React.createRef()

    @toggleDropdown     = @toggleDropdown.bind(this)
    @handleKeyDown      = @handleKeyDown.bind(this)
    @renderEngineButton = @renderEngineButton.bind(this)

  componentDidUpdate: (prevProps) ->
    if @state.open
      addedEngine = @props.topEngines.find((engine) => !prevProps.topEngines.includes(engine))

      if addedEngine && @engineButtonRefs[addedEngine]?.current
        element = $(@engineButtonRefs[addedEngine].current)

        element.addClass('added')
        element.one('animationend', => element.removeClass('added')) #Use .one to handle event only once and avoid manual unbinding

  handleClickOutside: (e) ->
    @closeDropdown()

  handleKeyDown: (e) ->
    if @state.open
      e.preventDefault() if e.code in ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']

      switch(e.code)
        when 'Escape'              then @closeDropdown()
        when 'ArrowUp'             then @focusPrevEngine(e.target)
        when 'ArrowDown'           then @focusNextEngine(e.target)
        when 'ArrowLeft'           then @focusOthersButton()      if $(e.target).closest('.other-engines').length
        when 'ArrowRight', 'Space' then @focusLastOtherEngine()   if $(e.target).hasClass('other-engines-button')

  focusPrevEngine: (element) ->
    @focusSiblingEngine(element, -1)

  focusNextEngine: (element) ->
    @focusSiblingEngine(element, 1)

  focusSiblingEngine: (element, offset) ->
    parent = $(element).closest('.engine-dropdown')

    if parent
      children = parent.find('> button, > * > button').toArray() # First- and second-level children buttons
      index    = children.indexOf(element)
      sibling  = children[index + offset]

      sibling.focus() if sibling

  focusOthersButton: ->
    @othersButtonRef.current.focus()

  focusLastOtherEngine: ->
    buttons = @othersDropdownRef.current.children
    buttons[buttons.length - 1].focus()

  toggleDropdown: ->
    @setState(open: !@state.open)

  closeDropdown: ->
    @setState(open: false) if @state.open

  removeTopEngine: (engine, e) ->
    e.stopPropagation() # Parent is also a button
    @props.removeTopEngine(engine)

  onClickEngine: (engine, e) ->
    if !@isSelectableEngine(engine)
      @closeDropdown()
      @props.scrollToPricing('engine')
    else
      isKeyboardClick = (e.detail == 0)
      @props.selectEngine(engine)
      @closeDropdown() if @isTopEngine(engine) || isKeyboardClick

  isCurrentEngine: (engine) ->
    engine == @props.engine

  isTopEngine: (engine) ->
    @props.topEngines.includes(engine)

  isSelectableEngine: (engine) ->
    @props.engines[engine].selectable

  sortEngines: (engines) ->
    engines.sort((a, b) =>
      first = @props.engines[a]
      other = @props.engines[b]

      firstScore = if first.plan == 'premium' then 0 else 1
      otherScore = if other.plan == 'premium' then 0 else 1

      if firstScore != otherScore
        firstScore - otherScore
      else
        first.label.localeCompare(other.label, { sensitivity: "base" })
    )

  render: ->
    <div className="engine-dropdown-wrapper">
      { @renderDropdown() }
    </div>

  renderDropdown: ->
    classes = "engine-dropdown"
    classes += " open" if @state.open

    <div className={classes}
         onKeyDown={@handleKeyDown}>
      { @renderOthersWrapper() if @state.open }
      { @renderTopEngines()    if @state.open }
      { @renderDivider()       if @state.open }
      { @renderTitleButton() }
    </div>

  renderOthersWrapper: ->
    engines = _.difference(Object.keys(@props.engines), @props.topEngines)

    if engines.length
      <>
        <div className="other-engines">
          { @renderOthersButton() }
          { @renderOthersDropdown(engines) }
        </div>
        { @renderDivider() }
      </>

  renderOthersButton: ->
    <button className="btn other-engines-button"
            ref={@othersButtonRef}
            onMouseDown={(e) => e.preventDefault()}>
      { @renderButtonLabel(@props.i18n.addOtherModel) }
      <i className="fas fa-long-arrow-right" />
    </button>

  renderOthersDropdown: (engines) ->
    <div className="engine-dropdown"
         ref={@othersDropdownRef}>
      { @sortEngines(engines).map(@renderEngineButton) }
    </div>

  renderTopEngines: ->
    <div className="top-engines">
      {@sortEngines(@props.topEngines).map(@renderEngineButton)}
    </div>

  renderTitleButton: ->
    if @state.open
      leftIcon  = <RobotIcon />
      label     = @renderButtonLabel(@props.i18n.select)
      rightIcon = <i className="fas fa-angle-up" />
    else
      leftIcon  = @renderStarIcon(@props.engine)
      label     = @renderButtonLabel(@props.engines[@props.engine].label)
      rightIcon = <i className="fas fa-angle-down" />

    <button className="btn btn-title"
            title={@props.engines[@props.engine].name}
            onClick={@toggleDropdown}>
      { leftIcon  }
      { label     }
      { rightIcon }
    </button>

  renderEngineButton: (engine) ->
    classes = "btn engine-button"
    title   = @props.engines[engine].name

    if @isCurrentEngine(engine)
      classes += " current"
    else if !@isSelectableEngine(engine)
      classes  += " locked"

    <button className={classes}
            key={engine}
            ref={@engineButtonRefs[engine] if @isTopEngine(engine)}
            title={title}
            onClick={@onClickEngine.bind(this, engine)}>
      { @renderStarIcon(engine) }
      { @renderButtonLabel(@props.engines[engine].label) }

      { @renderActionIcon(engine) if @isTopEngine(engine) }
    </button>

  renderActionIcon: (engine) ->
    if @isCurrentEngine(engine)
      classes    = "action-icon current-model"
      otherProps =
        title: @props.i18n.currentModel

      iconClasses = "fas fa-check"
    else
      classes    = "action-icon remove-model"
      otherProps =
        title:   @props.i18n.removeModel
        onClick: @removeTopEngine.bind(this, engine)

      iconClasses = "fas fa-times"

    <div className={classes} {...otherProps}>
      <i className={iconClasses} />
    </div>

  renderButtonLabel: (label) ->
    <span className="label">
      {label}
    </span>

  renderStarIcon:(engine) ->
    if @props.engines[engine].plan == 'premium'
      classes = "far fa-star premium-star"
      title   = @props.i18n.premiumStarTitle
    else
      classes = "far fa-star basic-star"
      title   = @props.i18n.basicStarTitle

    <i className={classes} title={title} />

  renderDivider: ->
    <hr />

export default onClickOutside(EngineDropdown)
